import maplibregl from 'maplibre-gl';
import { GeoJsonProperties, Geometry, Feature } from 'geojson';

import { ARTIFACTS_ICON_DICTIONARY, LAYERS, SOURCE_IDS } from './mapConstants';
import { drawPoints, drawLines, drawPolygon } from './mapGeoJSONUtils';

// Utilities to add and remove layers to map ==================
export const removeLines = (map: { current: maplibregl.Map | null }) => {
  if (!map.current) {
    return;
  }

  // REMOVE LINES LAYER
  const linesLayer = map.current.getStyle()?.layers.find((l: any) => l.id === LAYERS.lines);
  const linesSource = map.current.getSource(SOURCE_IDS.lines);

  if (linesLayer) {
    map.current.removeLayer(LAYERS.lines);
  }
  if (linesSource) {
    map.current.removeSource(LAYERS.lines);
  }
};

export const removePoints = (map: { current: maplibregl.Map | null }) => {
  if (!map.current) {
    return;
  }

  const highlightLayerId = `${SOURCE_IDS.points}-highlight-ring`;
  if (map.current.getStyle()?.layers.find((l: any) => l.id === highlightLayerId)) {
    map.current.removeLayer(highlightLayerId);
  }

  const impactoRingId = 'impacto-snapshot-trafo-ring';
  if (map.current.getStyle()?.layers.find((l: any) => l.id === impactoRingId)) {
    map.current.removeLayer(impactoRingId);
  }

  const pointsLayer = map.current.getStyle()?.layers.find((l: any) => l.id === LAYERS.points);
  const pointsSource = map.current.getSource(SOURCE_IDS.points);

  if (pointsLayer) {
    map.current.removeLayer(LAYERS.points);
  }

  if (pointsSource) {
    map.current.removeSource(LAYERS.points);
  }
};

export const removePolygons = (map: { current: maplibregl.Map | null }) => {
  if (!map.current) {
    return;
  }

  // REMOVE THE SOURCE AND LAYER POLYGON
  const polygonsLayerFill = map.current
    .getStyle()
    ?.layers.find((l: any) => l.id === LAYERS.polygonFill);
  const polygonsLayerBorder = map.current
    .getStyle()
    ?.layers.find((l: any) => l.id === LAYERS.polygonBorder);
  const polygonsSource = map.current.getSource(SOURCE_IDS.polygon);

  if (polygonsLayerFill) {
    map.current.removeLayer(LAYERS.polygonFill);
  }

  if (polygonsLayerBorder) {
    map.current.removeLayer(LAYERS.polygonBorder);
  }

  if (polygonsSource) {
    map.current.removeSource(SOURCE_IDS.polygon);
  }
};

export const removeImages = (map: { current: maplibregl.Map | null }) => {
  if (!map.current) {
    return;
  }
  // REMOVE IMAGES
  const artifactNames = Object.keys(ARTIFACTS_ICON_DICTIONARY);

  for (let i = 0; i < artifactNames.length; i++) {
    if (map.current.hasImage(`marker-${artifactNames[i]}`)) {
      map.current.removeImage(`marker-${artifactNames[i]}`);
    }
  }
};

export const drawMapLayers = async (
  map: { current: maplibregl.Map | null },
  mapPointFeatures: Feature<Geometry, GeoJsonProperties>[],
  mapLineFeatures: Feature<Geometry, GeoJsonProperties>[],
  mapPolygonFeatures: Feature<Geometry, GeoJsonProperties>[]
) => {
  if (!map.current) {
    return;
  }

  // Make sure to remove points and line layers
  removeLines(map);
  removePoints(map);
  removePolygons(map);
  removeImages(map);

  drawLines(map, mapLineFeatures, SOURCE_IDS.lines);
  drawPolygon(map, mapPolygonFeatures, SOURCE_IDS.polygon);
  await drawPoints(map, mapPointFeatures, ARTIFACTS_ICON_DICTIONARY, SOURCE_IDS.points);
};
